import { Injectable } from '@angular/core';

@Injectable()
export abstract class VariableEnvironnementUserService {

}